'use client';

import { useState, useMemo, useRef, useEffect, useCallback } from 'react';

interface ProjectMetric {
  hires?: number;
  cph?: number;
  attendance?: number;
  sla?: number;
}

interface Project {
  id: string;
  year: number;
  industry: string;
  type: string;
  status: string;
  title: string;
  image: string;
  desc: string;
  metrics: ProjectMetric;
  tags: string[];
  steps: string[];
  results: string[];
}

const PROJECTS: Project[] = [
  {
    id: 'p1', year: 2025, industry: 'Торговля и маркетинг', type: 'RPO', status: 'Завершён',
    title: 'RPO для маркетплейса', image: 'https://placehold.co/800x480?text=E-commerce+RPO',
    desc: 'Массовый поток заявок и ускорение интервью; 7 сорсинг-каналов и автоматизация писем.',
    metrics: { hires: 180, cph: -19, attendance: 96, sla: 24 },
    tags: ['массовый найм', 'BI', 'SLA 24ч'],
    steps: ['Диагностика и бриф', 'Запуск 7 каналов', 'BI-дашборд воронки', 'Еженедельные ревью KPI'],
    results: ['180 закрытий/кв', 'CPH −19%', 'Средняя явка 96%', 'Замена за 24 ч']
  },
  {
    id: 'p2', year: 2025, industry: 'Транспорт и логистика', type: 'Массовый подбор', status: 'В работе',
    title: 'Операторы склада 24/7', image: 'https://placehold.co/800x480?text=Warehouse+Hiring',
    desc: 'Сменные графики, ночные слоты, оперативные замены.',
    metrics: { hires: 120, cph: -12, attendance: 93, sla: 24 },
    tags: ['склад', 'смены', 'remote-скрининг'],
    steps: ['План сменности', 'Гео-таргетинг объявлений', 'Онлайн-тесты'],
    results: ['120+ наймов', 'CPH −12%', 'Явка 93%']
  },
  {
    id: 'p3', year: 2025, industry: 'IT-сфера и Интернет', type: 'Аутстаффинг', status: 'Завершён',
    title: 'Служба поддержки L1/L2', image: 'https://placehold.co/800x480?text=Support+Outstaff',
    desc: 'Укомплектовали линию поддержки, ввели обучение и QA-контроль.',
    metrics: { hires: 45, cph: -10, attendance: 95, sla: 48 },
    tags: ['обучение', 'QA', 'SLA 48ч'],
    steps: ['Скрипты и rubrics', 'Наставники', 'QA-оценка звонков'],
    results: ['45 спецов', 'CSAT +18 п.п.']
  },
  {
    id: 'p4', year: 2025, industry: 'Торговля и маркетинг', type: 'MSP', status: 'Пилот',
    title: 'MSP-модель для сети магазинов', image: 'https://placehold.co/800x480?text=Retail+MSP',
    desc: 'Единые KPI и пул субподрядчиков под управлением INTERIM.',
    metrics: { hires: 90, cph: -15, attendance: 92, sla: 36 },
    tags: ['мультивендор', 'единые метрики'],
    steps: ['Онбординг партнёров', 'Единый SLA/качество', 'Еженедельные QBR'],
    results: ['Скорость +22%', 'CPH −15%']
  },
  {
    id: 'p5', year: 2025, industry: 'Сфера обслуживания', type: 'RPO', status: 'Завершён',
    title: 'RPO для колл-центра', image: 'https://placehold.co/800x480?text=Call+Center+RPO',
    desc: 'Поток кандидатов, тренинги, контроль явки.',
    metrics: { hires: 160, cph: -17, attendance: 94, sla: 24 },
    tags: ['обучение', 'воронка'],
    steps: ['Сорсинг + рекомендации', 'Слоты интервью', 'Тренинг soft-skills'],
    results: ['160 наймов', 'CPH −17%', 'Явка 94%']
  },
  {
    id: 'p6', year: 2025, industry: 'IT-сфера и Интернет', type: 'HR-процессы', status: 'Завершён',
    title: 'Автоматизация воронки', image: 'https://placehold.co/800x480?text=Funnel+Automation',
    desc: 'Интеграции с ATS/CRM, письма и статусы, отчётность.',
    metrics: { hires: 0, cph: -20, attendance: 0, sla: 0 },
    tags: ['ATS', 'CRM', 'webhooks'],
    steps: ['Схема интеграций', 'Шаблоны сообщений', 'BI-дашборды'],
    results: ['CPH −20%', 'Время отклика −35%']
  },
  {
    id: 'p7', year: 2025, industry: 'Педагогика', type: 'Обучение', status: 'Завершён',
    title: 'Академия сорсинга', image: 'https://placehold.co/800x480?text=Training',
    desc: 'Модульная программа для рекрутеров и HM, rubrics и чек-листы.',
    metrics: { hires: 0, cph: 0, attendance: 0, sla: 0 },
    tags: ['обучение', 'rubrics'],
    steps: ['Программа 30/60/90', 'Практикум', 'Сертификация'],
    results: ['Скорость закрытия −12% (после)']
  },
  {
    id: 'p8', year: 2025, industry: 'Строительство и ремонт', type: 'Аутсорс', status: 'Завершён',
    title: 'Сезонный аутсорс рекрутинга', image: 'https://placehold.co/800x480?text=Seasonal+Outsource',
    desc: 'Пик сезона — увеличили мощность команды на 3 месяца.',
    metrics: { hires: 70, cph: -9, attendance: 91, sla: 36 },
    tags: ['сезон', 'масштабирование'],
    steps: ['Экспресс-онбординг', 'Шаблоны коммуникации', 'Контроль качества'],
    results: ['+70 наймов', 'CPH −9%']
  },
];


const ALL_YEARS = PROJECTS.map(p => p.year);
const MIN_YEAR = Math.min(...ALL_YEARS);
const MAX_YEAR = Math.max(...ALL_YEARS);


const formatYear = (year: number): string => {
  return String(year);
};

const formatYearWithSuffix = (year: number): string => {
  return `${year} г.`;
};


const fmtCPH = (value: number) => {
  if (value > 0) return `+${value}%`;
  if (value < 0) return `−${Math.abs(value)}%`;
  return `0%`;
};

const Kpis = () => {
  const kpiData = [
    { label: 'Закрытий в мес.', value: 150, unit: '+' },
    { label: 'Экономия', value: 20, unit: '%', isImpact: true },
    { label: 'Время найма', value: 14, unit: ' д.', isImpact: true },
    { label: 'Явка', value: 95, unit: '%' }
  ];

  const counterRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLDivElement;
            const to = Number(el.dataset.to);
            const duration = 900;
            const start = performance.now();
            const step = (now: number) => {
              const progress = Math.min(1, (now - start) / duration);
              el.textContent = `${Math.floor(to * progress)}`;
              if (progress < 1) {
                requestAnimationFrame(step);
              }
            };
            requestAnimationFrame(step);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.5 }
    );

    counterRefs.current.forEach(ref => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      counterRefs.current.forEach(ref => {
        if (ref) {
          observer.unobserve(ref);
        }
      });
    };
  }, []);

  return (
    <section className="grid gap-4 md:grid-cols-4 lg:gap-6">
      {kpiData.map((kpi, index) => (
        <article key={kpi.label} className="card p-4 rounded-xl flex flex-col justify-center">
          <p className="text-sm font-light text-gray-300">{kpi.label}</p>
          <div className="flex items-end mt-1">
            <div
              ref={el => { counterRefs.current[index] = el; }}
              className="text-3xl md:text-4xl font-extrabold"
              data-to={kpi.value}
            >
              0
            </div>
            <span className="text-lg md:text-xl font-bold ml-1">{kpi.unit}</span>
          </div>
          {kpi.isImpact && <p className="text-xs text-green-400 mt-1">в сравнении с инхаус-наймом</p>}
        </article>
      ))}
    </section>
  );
};

interface ProjectCardProps {
  project: Project;
  onOpenModal: (project: Project) => void;
}
const ProjectCard = ({ project, onOpenModal }: ProjectCardProps) => {
  const { title, year, industry, type, status, desc, image, metrics, tags } = project;
  return (
    <article className="card rounded-2xl overflow-hidden flex flex-col">
      <img
        src={image}
        alt=""
        width={800}
        height={480}
        className="w-full h-44 object-cover"
      />
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center justify-between">
          <h3 className="text-xl font-semibold">{title}</h3>
          <span className="tag">{formatYear(year)}</span>
        </div>
        <div className="mt-2 text-xs flex flex-wrap gap-2">
          <span className="tag">{industry}</span>
          <span className="tag">{type}</span>
          <span className="tag">{status}</span>
        </div>
        <p className="text-sm text-gray-200 mt-3 line-clamp-3">{desc}</p>
        <div className="mt-3 flex flex-wrap gap-2 text-xs">
          {metrics.hires && <span className="kpi">Закрыто: {metrics.hires}</span>}
          {metrics.cph && <span className="kpi">CPH: {fmtCPH(metrics.cph)}</span>}
          {metrics.attendance && <span className="kpi">Явка: {metrics.attendance}%</span>}
          {metrics.sla && <span className="kpi">SLA: {metrics.sla} ч</span>}
        </div>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex gap-2 flex-wrap">{tags.slice(0, 3).map(t => <span key={t} className="tag">{t}</span>)}</div>
          <button className="btn btn-ghost text-sm" onClick={() => onOpenModal(project)}>Подробнее</button>
        </div>
      </div>
    </article>
  );
};

interface ProjectModalProps {
  project: Project;
  onClose: () => void;
}
const ProjectModal = ({ project, onClose }: ProjectModalProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-blue-950 bg-opacity-90" onClick={onClose}>
      <div className="card rounded-2xl p-6 max-w-3xl w-[92%] relative overflow-y-auto max-h-[90vh]" onClick={e => e.stopPropagation()}>
        <button className="absolute right-3 top-3 px-2 py-1 rounded-lg btn-ghost" onClick={onClose}>✕</button>
        <div className="grid gap-4 md:grid-cols-2">
          <img
            src={project.image}
            alt=""
            width={800}
            height={480}
            className="rounded-xl w-full h-56 object-cover"
          />
          <div>
            <h3 className="text-2xl font-bold">{project.title}</h3>
            <div className="mt-2 text-xs flex flex-wrap gap-2">
              <span className="tag">{project.industry}</span>
              <span className="tag">{project.type}</span>
              <span className="tag">{project.status}</span>
              <span className="tag">{formatYearWithSuffix(project.year)}</span>
            </div>
            <p className="text-sm text-gray-200 mt-3">{project.desc}</p>
            <div className="mt-3 flex flex-wrap gap-2 text-xs">
              {project.metrics.hires && <span className="kpi">Закрыто: {project.metrics.hires}</span>}
              {project.metrics.cph && <span className="kpi">CPH: {fmtCPH(project.metrics.cph)}</span>}
              {project.metrics.attendance && <span className="kpi">Явка: {project.metrics.attendance}%</span>}
              {project.metrics.sla && <span className="kpi">SLA: {project.metrics.sla} ч</span>}
            </div>
            <div className="mt-4 flex gap-2">
              <a href="#" className="btn btn-ghost">Скачать кейс (PDF)</a>
              <a href="#cta" className="btn btn-accent">Обсудить похожий проект</a>
            </div>
          </div>
        </div>
        <div className="mt-6 grid gap-6 md:grid-cols-2">
          <div>
            <h4 className="font-semibold mb-2">Что сделали</h4>
            <ul className="text-sm text-gray-200 space-y-2">
              {project.steps.map(s => <li key={s}>• {s}</li>)}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Результаты</h4>
            <ul className="text-sm text-gray-200 space-y-2">
              {project.results.map(s => <li key={s}>• {s}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const industries = [...new Set(PROJECTS.map(p => p.industry))];
const types = [...new Set(PROJECTS.map(p => p.type))];
const statuses = [...new Set(PROJECTS.map(p => p.status))];

export default function Home() {
  const [query, setQuery] = useState('');
  const [industry, setIndustry] = useState('');
  const [type, setType] = useState('');
  const [status, setStatus] = useState('');
  const [yearRange, setYearRange] = useState({ start: MIN_YEAR, end: MAX_YEAR });
  const [sort, setSort] = useState('year');
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  const handleStartYearChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newStart = Number(e.target.value);
    setYearRange(prev => ({
      start: newStart,
      end: Math.max(newStart, prev.end)
    }));
  }, []);

  const handleEndYearChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newEnd = Number(e.target.value);
    setYearRange(prev => ({
      start: Math.min(prev.start, newEnd),
      end: newEnd
    }));
  }, []);


  const filteredProjects = useMemo(() => {
    let items = PROJECTS.filter(p => {
      const q = query.toLowerCase();
      const matchesQuery = !q || (p.title + ' ' + p.desc + ' ' + p.tags.join(' ')).toLowerCase().includes(q);
      const matchesIndustry = !industry || p.industry === industry;
      const matchesType = !type || p.type === type;
      const matchesStatus = !status || p.status === status;

      const matchesYear = p.year >= yearRange.start && p.year <= yearRange.end;

      return matchesQuery && matchesIndustry && matchesType && matchesStatus && matchesYear;
    });

    switch (sort) {
      case 'year':
        items.sort((a, b) => b.year - a.year);
        break;
      case 'impact':
        items.sort((a, b) => (b.metrics.cph || 0) - (a.metrics.cph || 0));
        break;
      case 'hires':
        items.sort((a, b) => (b.metrics.hires || 0) - (a.metrics.hires || 0));
        break;
      default:
        break;
    }
    return items;
  }, [query, industry, type, status, yearRange, sort]);

  return (
    <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-gray-100">
      <header className="px-6 pt-32 pb-16 md:pt-40 md:pb-20"
        style={{ background: 'linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.25)), radial-gradient(1200px 600px at 70% -10%, rgba(255,255,255,.08), transparent)' }}>
        <div className="max-w-7xl mx-auto">
          <nav className="mb-6 flex flex-wrap gap-3 text-sm">
            <a href="#portfolio" className="chip px-3 py-1 rounded-full hover:bg-white/25">Портфель</a>
            <a href="#method" className="chip px-3 py-1 rounded-full hover:bg-white/25">Методология</a>
            <a href="#faq" className="chip px-3 py-1 rounded-full hover:bg-white/25">FAQ</a>
            <a href="#cta" className="chip px-3 py-1 rounded-full hover:bg-white/25">Обсудить проект</a>
          </nav>
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">Проекты INTERIM</h1>
          <p className="max-w-3xl text-lg md:text-xl text-gray-200">
            Кейсы из ритейла, электронная коммерция, логистики и клиентского сервиса. Настоящие цифры: скорость, качество, стоимость найма.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#portfolio" className="btn btn-ghost">Смотреть портфель</a>
            <a href="#cta" className="btn btn-accent">Запросить оценку</a>
          </div>
        </div>
      </header>

      <main className="px-6 py-12 md:py-16 max-w-7xl mx-auto space-y-16">
        <Kpis />

        <section id="portfolio" className="scroll-mt-32">
          <div className="flex flex-wrap items-end gap-4 justify-between">
            <h2 className="text-3xl md:text-4xl font-bold">Портфель проектов</h2>
            <span id="count" className="text-sm text-gray-300">Найдено проектов: {filteredProjects.length}</span>
          </div>

          <div className="mt-4 grid gap-3 md:grid-cols-6">
            <input
              id="q"
              className="rounded-xl px-4 py-3 text-gray-900 md:col-span-2"
              placeholder="Поиск по названию/тегам…"
              value={query}
              onChange={e => setQuery(e.target.value)}
            />
            <select id="ind" className="rounded-xl px-4 py-3 text-gray-900" value={industry} onChange={e => setIndustry(e.target.value)}>
              <option value="">Отрасль: все</option>
              {industries.map(ind => <option key={ind}>{ind}</option>)}
            </select>
            <select id="type" className="rounded-xl px-4 py-3 text-gray-900" value={type} onChange={e => setType(e.target.value)}>
              <option value="">Тип: все</option>
              {types.map(t => <option key={t}>{t}</option>)}
            </select>

            <div className="rounded-xl px-4 py-3 card flex flex-col justify-center md:col-span-2">
              <div className="flex justify-between items-center text-sm text-gray-200 mb-1">
                <label>Годы:</label>
                <span>{yearRange.start} – {yearRange.end}</span>
              </div>
              <div className="flex items-center gap-2">
                <input
                  id="y1"
                  type="range"
                  min={MIN_YEAR}
                  max={MAX_YEAR}
                  value={yearRange.start}
                  onChange={handleStartYearChange}
                  className="flex-1 range range-sm range-primary"
                />
                <input
                  id="y2"
                  type="range"
                  max={MAX_YEAR}
                  min={MIN_YEAR}
                  value={yearRange.end}
                  onChange={handleEndYearChange}
                  className="flex-1 range range-sm range-secondary"
                />
              </div>
            </div>

            <select id="status" className="rounded-xl px-4 py-3 text-gray-900" value={status} onChange={e => setStatus(e.target.value)}>
              <option value="">Статус: все</option>
              {statuses.map(s => <option key={s}>{s}</option>)}
            </select>

            <select id="sort" className="rounded-xl px-4 py-3 text-gray-900 md:col-span-2" value={sort} onChange={e => setSort(e.target.value)}>
              <option value="year">Сортировать: по году ↓</option>
              <option value="impact">по эффекту (CPH)</option>
              <option value="hires">по количеству закрытий</option>
            </select>
          </div>

          <div id="grid" className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {filteredProjects.length > 0 ? (
              filteredProjects.map(project => (
                <ProjectCard key={project.id} project={project} onOpenModal={setSelectedProject} />
              ))
            ) : (
              <p id="empty" className="text-gray-300 md:col-span-3">Проекты не найдены — измените фильтры.</p>
            )}
          </div>
        </section>

        <section id="method" className="scroll-mt-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Как мы делаем проекты</h2>
          <div className="grid gap-6 md:grid-cols-4">
            <article className="card rounded-2xl p-6">
              <h3 className="text-xl font-semibold">1. Диагностика</h3>
              <p className="text-sm text-gray-200 mt-1">Бриф, аудит воронки, портрет идеального кандидата.</p>
            </article>
            <article className="card rounded-2xl p-6">
              <h3 className="text-xl font-semibold">2. Запуск</h3>
              <p className="text-sm text-gray-200 mt-1">Сорсинг-каналы, скрипты, слоты интервью, отчётность.</p>
            </article>
            <article className="card rounded-2xl p-6">
              <h3 className="text-xl font-semibold">3. Исполнение</h3>
              <p className="text-sm text-gray-200 mt-1">Еженедельные ревью KPI: CPH, явка, скорость, качество.</p>
            </article>
            <article className="card rounded-2xl p-6">
              <h3 className="text-xl font-semibold">4. Масштабирование</h3>
              <p className="text-sm text-gray-200 mt-1">Оптимизация, обучение, автоматизация, MSP-пул.</p>
            </article>
          </div>
        </section>

        <section id="faq" className="scroll-mt-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">FAQ</h2>
          <div className="space-y-3">
            <details className="simple-card">
              <summary className="cursor-pointer font-semibold">Можно ли начать с пилота?</summary>
              <p className="mt-2 text-sm text-gray-200">Да. 2–4 недели, фиксированные KPI и прозрачные условия.</p>
            </details>
            <details className="simple-card">
              <summary className="cursor-pointer font-semibold">Вы работаете с нашей ATS/CRM?</summary>
              <p className="mt-2 text-sm text-gray-200">Да — нативные интеграции и вебхуки; отчёты в BI.</p>
            </details>
            <details className="simple-card">
              <summary className="cursor-pointer font-semibold">Как считаете экономический эффект?</summary>
              <p className="mt-2 text-sm text-gray-200">Сравниваем CPH, скорость и удержание до/после, считаем ROI.</p>
            </details>
          </div>
        </section>

        <section
          id="cta"
          className="simple-card flex flex-col md:flex-row md:items-center md:justify-between scroll-mt-32"
        >
          <div>
            <h3 className="text-2xl font-bold">Обсудим ваш проект?</h3>
            <p className="text-sm text-gray-200 mt-1">Пришлите 3 факта: роли/объёмы, география, сроки — вернёмся с оценкой.</p>
          </div>
          <a href="/contacts" className="btn btn-accent mt-4 md:mt-0">Связаться</a>
        </section>
      </main>
      {selectedProject && <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />}
    </div>
  );
}